module.exports = __webpack_public_path__ + "static/media/search_24_px.a7b4c855.svg";